/**
 * FairwayBid – Feldbeschriftungen je Nutzertyp
 *
 * Sharetribe kennt pro Nutzerfeld nur eine Beschriftung. Felder, die beide
 * Seiten ausfuellen, muessen deshalb in der Console einen Kompromisstext
 * tragen ("Firma oder Golfanlage") – im Formular liest das fuer jede Seite
 * halb falsch. Hier setzen wir je Nutzertyp den passenden Text, ohne das Feld
 * zu doppeln: Es bleibt ein Datenfeld, bestehende Eintraege bleiben unberuehrt.
 *
 * Ohne Eintrag hier gilt weiter der Text aus der Console.
 */

export const LABELS_BY_USER_TYPE = {
  company_name: {
    provider: {
      label: 'Firma',
      helpText: 'Der Name, unter dem Sie auftreten – Handelsfirma oder Herstellername.',
    },
    customer: {
      label: 'Golfanlage',
      helpText: 'Der Name, unter dem Sie auftreten – Golfanlage oder Betreibergesellschaft.',
    },
  },
};

/**
 * Gibt die Feldkonfiguration mit der Beschriftung des jeweiligen Nutzertyps
 * zurueck. Ohne passenden Eintrag bleibt die Konfiguration unveraendert.
 */
export const applyUserTypeLabels = (fieldConfig, userType) => {
  const override = LABELS_BY_USER_TYPE[fieldConfig?.key]?.[userType];
  if (!override) return fieldConfig;

  // Die Formularfelder lesen die Beschriftung bevorzugt aus saveConfig.label,
  // deshalb muss sie dort mitgesetzt werden – sonst gewinnt der Console-Text.
  const saveConfig = fieldConfig?.saveConfig
    ? { ...fieldConfig.saveConfig, label: override.label }
    : { label: override.label };

  return { ...fieldConfig, ...override, saveConfig };
};
